module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Grid_List_Widgets Widget

(function (fox, $) {
	
	fox.registerWidget('Grid_List_Widgets', {

		configure: function () {
			this.collection = [];
			this.__itteration = 0;

			this.registerOptions('', {
				widgetsAliasPrefix: 'listItem',
				widgetsUniqIdField: 'id',
				visibleItems: false
			});
			
			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('.Widget', this.getOption('widgetsConfig'));

			if (this.getOption('collection')) {
				this.setCollection(this.getOption('collection'));
			}

			this.def = {
				autoRender: true,
				group: 'widgetViewList',
				embed: {
					location: 'lastChild',
					container: this.getOption('container') || this.getOption('embed.container')
				}
			};

			this.callParent('init', arguments);
		},

		setCollection: function (collection, render) {
			this.collection = collection;

			if (this.isRun() && render === true) {
				this.render();
			}
		},

		getCollection: function () {
			return this.collection;
		},

		running: function () {
			this.render();

			this.callParent('running', arguments);
		},

		activate: function () {
			this.render();
		
			this.callParent('activate', arguments);
		},

		deactivate: function () {
			this.cleanMemo();
		
			this.callParent('deactivate', arguments);
		},

		render: function () {
			this.__itteration = 0;
			this.cleanMemo();

			fox.each(this.getCollection(), this.treatRow, this);
		},

		treatRow: function (val, key) {
			var wClass, w, wAlias, cols, uniqIdField, uniqId, cVal;

			this.__itteration++;

			cVal = {};
			uniqIdField = this.getOption('widgetsUniqIdField');
			uniqId = val[uniqIdField] || key;

			if (cols = fox.clone(this.getOption('columns'))) {
				cols.unshift(cols.pop());

				this.def.embed.container = cols[(key + 1) % cols.length];
			}

			wClass = val.widget || this.getOption('wClass') || 'Widget';
			wAlias = [this.getOption('widgetsAliasPrefix'), uniqId].join('_');
			cVal.externalObj = fox.clone(val);
			cVal.externalObj._key = key;
			cVal.templateOptions = fox.clone(val);
			w = this.getEmbeddedWidget(wAlias);

			if (!w) {
				this.embedWidget(wAlias, wClass, fox.merge(cVal, this.def)).run();
			} else {
				w.activate();
			}

			if (fox.isNumeric(this.getOption('visibleItems'))
				&& this.getOption('visibleItems') === this.__itteration) {
				this.__itteration = 0;

				throw fox.break;
			}

			if (this.__itteration === this.getCollection().length) {
				this.__itteration = 0;
			}
		},

		cleanMemo: function () {
			fox.each(this.getWidgetsByGroup('widgetViewList'), function (w) {
				w.removeSelf();
			});

			this._reactivationPool = [];
		}

	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/grid/list/widgets.js
// module id = 192
// module chunks = 2